import React from 'react';
import Icon from '../../../components/AppIcon';

const VideoTutorial = ({ video }) => {
  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden hover:shadow-lg transition-all group">
      <div className="relative aspect-video bg-muted">
        <img 
          src={video?.thumbnail} 
          alt={video?.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <button className="w-16 h-16 bg-primary rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform">
            <Icon name="Play" size={28} color="#ffffff" />
          </button>
        </div>
        <div className="absolute bottom-3 right-3 px-2 py-1 bg-black/80 rounded text-xs text-white">
          {video?.duration}
        </div>
      </div>

      <div className="p-5">
        <h3 className="text-lg font-heading font-bold text-foreground mb-2 group-hover:text-primary transition-colors line-clamp-2">
          {video?.title}
        </h3>
        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
          {video?.description}
        </p>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center space-x-1 text-sm text-muted-foreground">
            <Icon name="Eye" size={16} />
            <span>{video?.views} views</span>
          </div>
          <button className="text-sm text-primary hover:underline">
            Watch Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoTutorial;